import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import BLDWebsiteUser from "./BLDWebsiteTabsContent/BLDWebsiteUser";
import BLDWebsiteIncome from "./BLDWebsiteTabsContent/BLDWebsiteIncome";
import BLDWebsitePerformance from "./BLDWebsiteTabsContent/BLDWebsitePerformance";

const BLDWebsiteTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
  }

  function TabPanel({ children, value, index }: TabPanelProps) {
    return (
      <div hidden={value !== index}>
        {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        centered
        sx={{
          "& .MuiTabs-scrollButtons": {
            color: colors.GrayDarkMode[700].$value,
          },
          background: colors.GrayLightMode[100].$value,
          borderTop: "2px solid" + colors.GrayLightMode[100].$value,
          borderBottom: "2px solid" + colors.GrayLightMode[100].$value,
          borderRadius: spacing.Radius.md.$value,
          minHeight: spacing.Spacing["4xl"].$value,
          mb: 1,
        }}
        TabIndicatorProps={{
          sx: {
            height: spacing.Spacing.none.$value,
          },
        }}
      >
        {["User", "Income", "Performance"].map((label) => (
          <Tab
            key={label}
            label={label}
            disableRipple 
            sx={{
              width: "33%",
              color: colors.GrayDarkMode[500].$value,
              textTransform: "none",
              fontWeight: typography.Font_weight.Regular.$value,
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.xs.$value,
              padding: 0,
              minHeight: spacing.Spacing["4xl"].$value,
              "&.Mui-selected": {
                color: colors.GrayDarkMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                backgroundColor: colors.Base.White.$value + "!important",
              },
              "&:hover": { backgroundColor: "transparent" },
            }}
          />
        ))}
      </Tabs>

      {/* 🔽 TAB CONTENTS */}
      <TabPanel value={value} index={0}>
        <BLDWebsiteUser />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <BLDWebsiteIncome />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <BLDWebsitePerformance />
      </TabPanel>
    </>
  );
};

export default BLDWebsiteTabs;
